export default __webpack_public_path__ + "static/media/students_graphic.48459549.png";